import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H18C22.4183 0 26 3.58172 26 8V18C26 22.4183 22.4183 26 18 26H8C3.58172 26 0 22.4183 0 18V8Z"
      fill="#00A07D"
    />
    <g clipPath="url(#clip0_235_16439)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.87874 5.46461C10.8683 5.05472 11.9289 4.84375 13 4.84375C14.0711 4.84375 15.1317 5.05472 16.1213 5.46461C17.1108 5.8745 18.01 6.47528 18.7673 7.23266C19.5247 7.99004 20.1255 8.88918 20.5354 9.87874C20.9453 10.8683 21.1562 11.9289 21.1562 13C21.1562 14.0711 20.9453 15.1317 20.5354 16.1213C20.1255 17.1108 19.5247 18.01 18.7673 18.7673C18.01 19.5247 17.1108 20.1255 16.1213 20.5354C15.1317 20.9453 14.0711 21.1562 13 21.1562C11.9289 21.1562 10.8683 20.9453 9.87874 20.5354C8.88918 20.1255 7.99004 19.5247 7.23266 18.7673C6.47528 18.01 5.8745 17.1108 5.46461 16.1213C5.05472 15.1317 4.84375 14.0711 4.84375 13C4.84375 11.9289 5.05472 10.8683 5.46461 9.87874C5.8745 8.88918 6.47528 7.99004 7.23266 7.23266C7.99004 6.47528 8.88918 5.8745 9.87874 5.46461ZM13 6.2135C12.1088 6.2135 11.2263 6.38904 10.4029 6.73009C9.57954 7.07115 8.83141 7.57104 8.20122 8.20122C7.57104 8.83141 7.07115 9.57954 6.73009 10.4029C6.38904 11.2263 6.2135 12.1088 6.2135 13C6.2135 13.8912 6.38904 14.7737 6.73009 15.5971C7.07115 16.4205 7.57104 17.1686 8.20122 17.7988C8.83141 18.429 9.57954 18.9289 10.4029 19.2699C11.2263 19.611 12.1088 19.7865 13 19.7865C13.8912 19.7865 14.7737 19.611 15.5971 19.2699C16.4205 18.9289 17.1686 18.429 17.7988 17.7988C18.429 17.1686 18.9289 16.4205 19.2699 15.5971C19.611 14.7737 19.7865 13.8912 19.7865 13C19.7865 12.1088 19.611 11.2263 19.2699 10.4029C18.9289 9.57954 18.429 8.83141 17.7988 8.20122C17.1686 7.57104 16.4205 7.07115 15.5971 6.73009C14.7737 6.38904 13.8912 6.2135 13 6.2135Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9747 10.8554C16.2422 11.1229 16.2422 11.5565 15.9747 11.824L12.6541 15.1446C12.3867 15.412 11.953 15.412 11.6856 15.1446L10.0253 13.4843C9.7578 13.2168 9.7578 12.7832 10.0253 12.5157C10.2927 12.2483 10.7264 12.2483 10.9938 12.5157L12.1698 13.6917L15.0062 10.8554C15.2736 10.588 15.7073 10.588 15.9747 10.8554Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_235_16439">
        <rect width="18" height="18" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);

const SuccessIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default SuccessIcon;
